import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { PropertyGroup } from '../../components';
import Grid from '@material-ui/core/Grid';
import { richText } from '../../util/richText';
import css from './ListingPage.module.css';

const SectionFeaturesMaybe = props => {
  const { options, publicData, practicalInfo, subscriptionSection, hideSubscription } = props;
  if (!publicData) {
    return null;
  }
  const selectedOptions =
    publicData && publicData.vehicleCompatibility ? publicData.vehicleCompatibility : [];
  const access =
    publicData && publicData.bookingType
      ? publicData.bookingType === 'request'
        ? 'manuelle'
        : 'automatique'
      : '';
  const wayToOpen = publicData && publicData.parkingWayToOpen ? publicData.parkingWayToOpen : '';
  const goodToKnow = publicData && publicData.specialInfo ? publicData.specialInfo : '';
  const MIN_LENGTH_FOR_LONG_WORDS_IN_DESCRIPTION = 20;
  return (
    <div className={css.sectionFeatures}>
      <h2 className={css.featuresTitle}>
        <FormattedMessage id="ListingPage.vehicleCompatibilityTitle" />
      </h2>
      <PropertyGroup
        id="ListingPage.amenities"
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={true}
      />
      <br />

      {practicalInfo}

      {/* ways to enter */}
      {wayToOpen && (
        <>
          <h2 className={css.featuresTitle}>
            <FormattedMessage id="ListingPage.access" />
          </h2>
          <Grid container xs={12} justify={'flex-start'}>
            {/* <Grid item xs={12}>
          <div className={css.text}>
            {access}
          </div>
        </Grid> */}

            <Grid item xs={12}>
              <div className={css.text}>
                <p className={css.description}>
                  {richText(wayToOpen, {
                    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_DESCRIPTION,
                    longWordClass: css.longWord,
                  })}
                </p>
              </div>
            </Grid>
          </Grid>
        </>
      )}

      {/* Good to know */}
      {goodToKnow && (
        <>
          <br />
          <h2 className={css.featuresTitle}>
            <FormattedMessage id="ListingPage.goodToKnow" />
          </h2>

          <Grid container xs={12}>
            <Grid item xs={12}>
              <div className={css.text}>
                <p className={css.description}>
                  {richText(goodToKnow, {
                    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_DESCRIPTION,
                    longWordClass: css.longWord,
                  })}
                </p>
              </div>
            </Grid>
          </Grid>
        </>
      )}

      {!hideSubscription && subscriptionSection}
    </div>
  );
};

export default SectionFeaturesMaybe;
